// extracted by mini-css-extract-plugin
export var arrow = "_ck-1";
export var content = "_ck-0";
export var highlighted = "_ck-2";